import { apiCall } from "@/shared/services/apiCall.js";
import { errorToast } from "@/shared/services/helper.js";
import store from "@/store";

const getWalletAuth = async () => {
    try{
        store.dispatch('setGlobalLoader', true);
        let config = null

        let response = await apiCall('get','GET_WALLET_CONFIG', null, 'wallet')
        store.dispatch('setGlobalLoader', false);
        if (response && response.status == 200) {
            if (response?.data?.error) {
                errorToast(response.data.error);
            }else{
                config = response.data.data

                const defaults = ['100', '200', '500', '1000'];
                let stake_button = store.getters.userTransactionStakes || (config.stake_button?.every(x => Number(x) === 0) ? defaults : config.stake_button || defaults);
                config.stake_button = stake_button;
                store.dispatch('setUserTransactionStakes', stake_button);
            } 
            return { data: config};
        }
    }catch(error){
        store.dispatch('setGlobalLoader', false);
        if (error) {
            errorToast(error);
        }
    }
};

export {
    getWalletAuth
}